var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5918 8.125H12.733C12.478 7.12881 11.951 6.22474 11.212 5.51552C10.473 4.8063 9.5516 4.32037 8.55247 4.11294C7.55333 3.90551 6.51655 3.9849 5.55991 4.34209C4.60328 4.69929 3.76516 5.31996 3.1408 6.13357C2.51643 6.94719 2.13085 7.92114 2.02786 8.94474C1.92488 9.96835 2.10863 11.0006 2.55822 11.9241C3.00782 12.8476 3.70523 13.6255 4.57122 14.1692C5.43721 14.7129 6.43706 15.0008 7.45714 15H13.5918C14.4957 15 15.3626 14.6378 16.0018 13.9932C16.6409 13.3485 17 12.4742 17 11.5625C17 10.6508 16.6409 9.77648 16.0018 9.13182C15.3626 8.48716 14.4957 8.125 13.5918 8.125Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.daeef71b883b76b629688a5efce71647.svg";
export { ForwardRef as ReactComponent };